import ProjectV2item from "./ProjectV2item";
import "../component/ProjectV2xx.css";
import React from "react";


function ProjectV2() {
  return (
    <div className="projectlist-container">
      <p className="projectlist-container-title">Projects</p>
      <div>
        <ProjectV2item />
      </div>
    </div>
  );
}

export default ProjectV2;
